import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setPermissionGeolocation, setPosition } from '../store/actions';

// GeolocationPositionError codes
const PERMISSION_DENIED = 1;
const POSITION_UNAVAILABLE = 2;

/**
 * permissionGeolocation values:
 * - 'granted'     : a position has been received
 * - 'denied'      : permission is blocked (browser won't re-prompt)
 * - 'unavailable' : permission ok but location service is off / unsupported
 */
export const useGeolocation = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    let watchId;

    const markNotGranted = status => {
      dispatch(setPosition(null));
      dispatch(setPermissionGeolocation(status));
    };

    if (!navigator.geolocation) {
      markNotGranted('unavailable');
      return undefined;
    }

    // start watching position
    watchId = navigator.geolocation.watchPosition(
      pos => {
        const { latitude, longitude } = pos.coords;

        dispatch(setPosition({ latitude, longitude }));
        dispatch(setPermissionGeolocation('granted'));
      },
      err => {
        // TIMEOUT is transient (slow GPS fix): keep the last known state
        // instead of treating it as location being disabled
        if (err.code === PERMISSION_DENIED) markNotGranted('denied');
        if (err.code === POSITION_UNAVAILABLE) markNotGranted('unavailable');
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0
      }
    );

    return () => {
      navigator.geolocation.clearWatch(watchId);
    };
  }, [dispatch]);
};
